/* Cozy Cabaret: when a shopper clicks an option value that can't be combined with
   their other current choices (for example Black + Bar Stool doesn't exist), switch
   the other options to the closest real variant with that value, so its photo and
   price load instead of "Unavailable". Runs before the theme's own change handler. */
(function () {
  if (window.__ccVariantSnap) return;
  window.__ccVariantSnap = true;

  function readValue(group) {
    var radio = group.querySelector('input[type="radio"]:checked');
    if (radio) return radio.value;
    var select = group.querySelector('select');
    return select ? select.value : null;
  }

  function snap(vs, changedEl) {
    var mapEl = vs.querySelector('script[data-variant-options]');
    if (!mapEl) return;
    var variants;
    try { variants = JSON.parse(mapEl.textContent); } catch (e) { return; }
    var groups = Array.prototype.filter.call(vs.children, function (el) {
      return el.classList.contains('product-form__input');
    });
    if (groups.length < 2 || !Array.isArray(variants) || !variants.length) return;
    var current = groups.map(readValue);
    var exists = variants.some(function (v) {
      return v.options.every(function (o, i) { return o === current[i]; });
    });
    if (exists) return;
    var idx = groups.findIndex(function (g) { return g.contains(changedEl); });
    if (idx < 0) return;
    var candidates = variants.filter(function (v) { return v.options[idx] === current[idx]; });
    if (!candidates.length) return;
    function score(v) {
      return (v.available ? 100 : 0) + v.options.filter(function (o, i) { return o === current[i]; }).length;
    }
    var best = candidates.reduce(function (a, b) { return score(b) > score(a) ? b : a; });
    groups.forEach(function (group, i) {
      if (i === idx) return;
      var wanted = best.options[i];
      var radio = Array.prototype.find.call(group.querySelectorAll('input[type="radio"]'), function (r) {
        return r.value === wanted;
      });
      if (radio) {
        radio.checked = true;
        var label = group.querySelector('[data-selected-value]');
        if (label) label.innerHTML = wanted;
        return;
      }
      var select = group.querySelector('select');
      if (!select) return;
      Array.prototype.forEach.call(select.options, function (option) {
        if (option.value === wanted) {
          select.value = wanted;
          option.setAttribute('selected', 'selected');
        } else {
          option.removeAttribute('selected');
        }
      });
    });
  }

  document.addEventListener('change', function (event) {
    var t = event.target;
    var vs = t && t.closest ? t.closest('variant-selects') : null;
    if (vs) snap(vs, t);
  }, true);
})();